import { useEffect, useState } from 'react';
import { Box, Divider, Paper, Stack, Typography } from '@mui/material';
import { ColorModeToggle } from '../components/ColorModeToggle';
import { api } from '../lib/api';

export function Settings() {
  // The real deployed version comes from the backend APP_VERSION env var
  // (stamped at container build time by semantic-release). frontend/package.json
  // stays at 0.0.0 locally because it's only bumped in CI, so it's not a
  // useful source here.
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.get<{ status: string; version: string }>('/health')
      .then((res) => {
        if (!cancelled) setVersion(res.data.version || 'unknown');
      })
      .catch(() => {
        if (!cancelled) setVersion('unavailable');
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <Stack spacing={3}>
      <Typography
        variant="h3"
        component="h1"
        align="center"
      >
        Settings
      </Typography>

      <Paper sx={{ p: { xs: 2.5, sm: 4 } }}>
        <Stack spacing={4}>
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Appearance
            </Typography>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ py: 1 }}
            >
              <Typography variant="body1">Dark mode</Typography>
              <ColorModeToggle />
            </Stack>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              About
            </Typography>
            <Stack spacing={0.5}>
              <Typography variant="body1">WAF admin portal</Typography>
              <Typography variant="body2" color="text.secondary">
                Version {version ?? 'loading…'}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Paper>
    </Stack>
  );
}
